import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { getUsersList, deleteUser } from '../../../../Store/Actions/Users';

import View from './Components';


export default compose(
  connect(
    state => ({
      permissions: state.auth.permissions,
      isAuthenticated: state.auth.isAuthenticated,
      current_page: state.users.current_page,
      current: state.users.current,
      list: state.users.list,
      total: state.users.total,
      last_page: state.users.last_page,
      isLoading: state.users.isLoading,
      error: state.users.error
    }), { getUsersList, deleteUser },
  ),
  withState("filter", "setFilter", {
    sort: {
      column: 'updated_at',
      direction: 'ascending'
    },
    page: 1
  }),
  
  withState("openConfirmDeleteDialog", "setOpenConfirmDeleteDialog", false),
  withState("deletedId", "setDeletedId", -1),
  withHandlers({
    handleSortTableColumn: props => (column) => {
        props.setFilter({
            ...props.filter,
            sort: {
                ...props.filter.sort,
                column: column,
                //direction: props.filter.sort.direction === 'ascending' ? 'descending' : 'ascending'
            }
        });
        props.getWeldersList(props.filter);
    },
    handleSortTableDir: props => (dir) => {
      props.setFilter({
          ...props.filter,
          sort: {
              ...props.filter.sort,
              //column: column,
              direction: dir//props.filter.sort.direction === 'ascending' ? 'descending' : 'ascending'
          }
      });
      props.getWeldersList(props.filter);
  },
  handlePaginationChange: props => (e, { activePage }) => {
      props.setFilter({...props.filter, page: activePage},() => { props.getUsersList({...props.filter, page: activePage}) })
  }
  }),
  lifecycle({
    componentDidMount() {
      this.props.getUsersList(this.props.filter);
    }
  })
)(View);